import type { ReactNode } from "react"
import { useLocation, useNavigate } from "@tanstack/react-router"

import { Tabs, TabsList, TabsTrigger } from "@productlane/ui"

import { customersTabForPath } from "./customers-tab-path"
import { PageHeader } from "./page-header"

export const CustomersTabs = () => {
	const navigate = useNavigate()
	const location = useLocation()

	const value = customersTabForPath(location.pathname)

	return (
		<Tabs
			value={value}
			onValueChange={(next) => {
				void navigate({ href: next === "people" ? "/people" : "/customers" })
			}}
		>
			<TabsList>
				<TabsTrigger value="companies">Companies</TabsTrigger>
				<TabsTrigger value="people">People</TabsTrigger>
			</TabsList>
		</Tabs>
	)
}

export const CustomersPageHeader = ({ actions }: { actions: ReactNode }) => (
	<PageHeader clearsNavToggle leading={<CustomersTabs />} actions={actions} />
)
